import locales from '../locales';
import {OptionProps} from 'antd/lib/select';
import {ColumnFilterItem} from 'antd/es/table';

export const DeliveryMethod = {
  COURIER: 'COURIER',
  PERSONAL: 'PERSONAL',
};

const deliveryMethodToText = {
  [DeliveryMethod.COURIER]: locales.delivery_method_courier,
  [DeliveryMethod.PERSONAL]: locales.delivery_method_personal,
};

export function getDeliveryMethodOptions(): OptionProps[] {
  return Object.keys(DeliveryMethod)
    .map(type => ({value: type, key: type, title: deliveryMethodToText[type]}));
}

export function getDeliveryMethodLabel(deliveryMethod?: string): string | undefined {
  return deliveryMethod ? deliveryMethodToText[deliveryMethod] : undefined;
}

export function getDeliveryMethodFilters(): ColumnFilterItem[] {
  return [DeliveryMethod.COURIER, DeliveryMethod.PERSONAL]
    .map(type => ({text: deliveryMethodToText[type], value: type}));
}


// WEBPACK FOOTER //
// ./src/common/DeliveryMethod.tsx